import { layoutMultilineText, PDFPage, TextAlignment } from "pdf-lib";
import { isNilOrEmpty } from "ramda-adjunct";
import { CommonDrawOptions, DocumentPlaceholder } from "../types";
import { isRTL } from "../utils";

export interface TextPlaceholderOptions {
  fontSize: number;
  text: string;
}

export const textDraw = (
  page: PDFPage,
  placeholder: DocumentPlaceholder<TextPlaceholderOptions>,
  { font }: CommonDrawOptions
) => {
  const placeholderText = placeholder.options.text;
  if (isNilOrEmpty(placeholderText)) {
    throw new Error("Text placeholder should have text");
  }

  const width = placeholder.width * page.getSize().width;

  const { lines } = layoutMultilineText(placeholderText, {
    alignment: isRTL(placeholderText) ? TextAlignment.Right : TextAlignment.Left,
    font: font!,
    fontSize: placeholder.options.fontSize,
    bounds: {
      height: placeholder.options.fontSize,
      width: placeholder.width * page.getSize().width,
      x: placeholder.x * page.getSize().width,
      y: page.getSize().height - placeholder.y * page.getSize().height - placeholder.options.fontSize,
    },
  });

  lines.forEach(({ text, x }, index) => {
    page.drawText(text, {
      x: x,
      y:
        page.getSize().height -
        placeholder.y * page.getSize().height -
        placeholder.options.fontSize -
        placeholder.options.fontSize * index,
      size: placeholder.options.fontSize,
      font: font,
      maxWidth: width,
    });
  });
};
